<ng-container *ngIf="container || message">
  <!-- CXP-6707 will cover slowly converting all entity hubs to using bff-driven ads -->
  <ng-container *ngIf="topContent; else hardCodedAd">
    <ng-container *ngFor="let item of topContent?.items; trackBy: trackById">
      <ng-container *ngIf="item.type === 'ad'">
        <div data-test="flo-ad-leaderboard">
          <flo-ad [ad]="item"></flo-ad>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
  <ng-template #hardCodedAd>
    <div
      leaderboard-large-ad
      class="
        my-4
        d-none d-lg-block
        position-relative
        justify-content-center
        lazy-leaderboard-container
      "
      data-test="leaderboard"
    >
      <ng-content select="[leaderboard-large]"></ng-content>
    </div>
  </ng-template>
  <!-- main content -->
  <div class="container rails-container min-vh-100 position-relative">
    <ng-container *ngIf="!isPartialError; else error">
      <main
        *ngIf="!isLoading || container?.type === 'container:filterable'; else loadingSpinner"
        class="main-content"
        data-test="entity-hub-main-content"
        >
        <ng-container *ngIf="message?.type === 'message'; else noMessage">
          <div class="py-4 px-3 px-lg-4">
            <flo-message [message]="message"></flo-message>
          </div>
        </ng-container>
        <ng-template #noMessage>
          <ng-container *ngIf="container?.type === 'container:filterable'">
            <flo-filterable-container [container]="container" [isLoading]="isLoading" (nextPage)="handleNextPage($event)" (toggleClicked)="handleToggleClicked($event)"></flo-filterable-container>
          </ng-container>
          <ng-container *ngIf="container?.type === 'grid:filterable'">
            <flo-filterable-grid [container]="container" [selectedItem]="selectedItem" (nextPage)="handleNextPage($event)"></flo-filterable-grid>
          </ng-container>
          <ng-container *ngIf="container?.type === 'grid:container'">
            <flo-grid-container [container]="container" [selectedItem]="selectedItem" (nextPage)="handleNextPage($event)"></flo-grid-container>
          </ng-container>
          <ng-container *ngIf="container?.type === 'container:two-column'">
            <flo-two-column-container [model]="container"></flo-two-column-container>
          </ng-container>
          <ng-container *ngIf="container?.type === 'container'">
            <flo-container [container]="container" (nextPage)="handleNextPage($event)" [geoBlockedIds]="geoBlockedIds">
            </flo-container>
          </ng-container>
        </ng-template>
      </main>
    </ng-container>

    <!-- right-rail -->
    <aside class="right-rail" data-test="right-rail" [ngClass]="{'d-none': hideRightRail}">
      <ng-container *ngIf="secondaryContainer?.type === 'container'">
        <div class="pb-2 h-100">
          <flo-container [container]="secondaryContainer" [height]="'100%'" [geoBlockedIds]="geoBlockedIds"></flo-container>
        </div>
      </ng-container>

    </aside>
  </div>

  <!-- xs, sm mobile ad between content and secondary content -->
  <div *ngIf="showFooterCTA" class="d-md-none w-100">
    <div class="justify-content-center lazy-flex-container my-3">
      <ng-content select="[rectangle-mobile]"></ng-content>
    </div>
  </div>

  <!-- md, lg ad between content and secondary content -->
  <div *ngIf="!bottomContent"  class="d-none d-md-block d-xl-none w-100 lazy-leaderboard-container">
    <div class="justify-content-center my-3">
      <ng-content select="[leaderboard-small]"></ng-content>
    </div>
  </div>

  <!-- secondary content on smaller screens -->
  <div>
    <ng-container *ngIf="!!description">
      <div class="d-xl-none container">
        <div class="main-content" data-test="description">
          <flo-expandable-text [expandableText]="description"></flo-expandable-text>
        </div>
      </div>
    </ng-container>
  </div>

  <div *ngIf="bottomContent" class="sticky-footer-ctas stick-to-footer">
    <ng-container *ngIf="imageWithButtons?.cta1 || imageWithButtons?.cta2">
      <div class="bg-white py-2 shadow" data-test="image-with-buttons">
        <div class="container">
          <flo-image-with-buttons [model]="imageWithButtons" [geoBlockedIds]="geoBlockedIds"></flo-image-with-buttons>
        </div>
      </div>
    </ng-container>
    <ng-container *ngFor="let item of bottomContent?.items; trackBy: trackById">
      <ng-container *ngIf="item.type === 'ad'">
        <div class="d-flex d-md-none justify-content-center w-100 adhesion-ad" data-test="flo-ad-adhesion">
          <flo-ad [ad]="item"></flo-ad>
        </div>
      </ng-container>
    </ng-container>
  </div>



  <div *ngIf="showFooterCTA && !bottomContent" class="sticky-footer-ctas stick-to-footer d-xl-none">
    <!-- Shows only the ctas as sticky -->
    <ng-container *ngIf="imageWithButtons?.cta1 || imageWithButtons?.cta2">
      <div class="bg-white pb-2 shadow" data-test="image-with-buttons">
        <div class="container">
          <flo-image-with-buttons [model]="imageWithButtons" [geoBlockedIds]="geoBlockedIds"></flo-image-with-buttons>
        </div>
      </div>
    </ng-container>
    <div class="adhesion-ad d-md-none">
      <ng-content select="[adhesion]"></ng-content>
    </div>
    <div class="adhesion-ad-medium d-none d-md-block d-lg-none">
      <ng-content select="[content-mobile]"></ng-content>
    </div>
  </div>
</ng-container>

<ng-template #error>
  <div class="main-content">
    <flo-error></flo-error>
  </div>
</ng-template>
<ng-template #loadingSpinner>
  <div data-test="entity-hub-spinner" class="d-flex spinner-container w-100">
    <div class="spinner-border text-light d-flex m-auto"></div>
  </div>
</ng-template>
